/* eslint-disable radix */
/* eslint-disable prefer-const */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/alt-text */
import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'

import moment from 'moment'

import clsx from 'clsx'
import { useLocation } from 'react-router-dom'

import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  LinearProgress,
  Radio,
  RadioGroup
} from '@material-ui/core'

import ButtonGZ from '../../components/Button'
import PaginationComponent from '../../components/PaginationComponent'
import TextAreaHtml from '../../components/TextAreaHtml'
import TopSearch from '../../components/TopSearch'
import useStyles from './styles'

// import clsx from 'clsx';

import Context from '../../context'
import { getListTags, getPartnersList, getSearch, getThemesList } from '../../services/ClubeApi'
import ImageUploadToS3 from '../../services/ImageUpload'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'
import CategorySelector from './components/selectCategory'
import ImageUpload from './components/imageUpload'

function MuralForm(props) {
  const navigation = props.history
  // ##################
  const classes = useStyles()
  const { setAboutCurrentPage, setShowLoadingModal } = useContext(Context)
  const { user, setUser } = useContext(Context)
  const [selectedDate, setSelectedDate] = useState(moment().utc().toISOString())
  const [openSchedule, setOpenSchedule] = useState(false)
  const data = props.location.state
  const [errors, setErrors] = useState(null)
  const [loading, setLoading] = useState(false)
  const [groupsData, setGroupsData] = useState([])
  let [associatedGroups, setAssociatedGroups] = useState([])
  const location = useLocation()
  const [checked, setChecked] = useState([])

  const [tags, setTags] = useState([])
  const [value, setValue] = React.useState()
  const [tagList, setTagList] = useState([])

  const [formData, setFormData] = useState({
    ...data,
    id: data?.id || '',
    title: data?.title || '',
    content: data?.content || '',
    image: data?.image || '',
    calltoaction: data?.calltoaction || '',
    link: data?.link || '',
    typeHighlight: data?.typeHighlight || location.state?.createTypeHighlight,
    whiteLabelId: data?.whiteLabelId,
    createdAt: data?.createdAt || '',
    situation: data?.situation || 1,
    partnerList: data?.partners || tags

  })

  // ----------------- partnerList -------------------

  const { setPartnerToEdit } = useContext(Context)
  const [searchData, setSearchData] = useState({ str: '', startSearch: false })
  const [page, setPage] = useState(0)
  const [totalPages, setTotalPages] = useState(5)
  const [fullPartnerList, setFullPartnerList] = useState([])
  const [filteredPartnerList, setFilteredFullPartnerList] = useState([])
  const [partnerList, setPartnerList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [filter, setFilter] = useState(0)
  const [tempList, setTempList] = useState([])
  const [isFiltered, setIsFiltered] = useState(false)

  const [showCategories, setShowCategories] = useState(false);
  const [selectedTag, setSelectedTag] = useState("");

  useEffect(() => {
    setFormData({ ...formData, slug: selectedTag})
  }, [selectedTag]);

  const listUpdate = async () => {
    setIsLoading(true)
    const actualPage = page || 1
    return getPartnersList(actualPage, 16)
  }

  useEffect(() => {
    if (!isAuthenticated) {
      history.replace('/')
      return
    }

    setUser(getLoggedUser)

    setSelectedDate(formData.publishedDate)
    const namePage = `${location.state.createTypeHighlight ? 'Novo' : 'Editar'} post de Destaque`
    setAboutCurrentPage({
      title: namePage,
      buttons: [{ title: 'Voltar', pathname: '/highlightslist' }]
    })

    const getTags = async () => {
      return getListTags()
    }

    getTags().then(r => {
      setTagList(
        r
          .map(item => {
            return {
              ...item,
              placeholder: `${item.TagsTop.description} | ${item.name}`
            }
          })
          .sort((a, b) => (a.placeholder < b.placeholder ? -1 : 1))
      )
    })

    // ------- partnerList ----------
    listUpdate()
      .then(res => {
        const { pagination } = res
        setFullPartnerList(res.data)
        setPage(pagination.page || 1)
        setTotalPages(pagination.totalPages || 1)
        setIsLoading(false)
      })
      .catch(error => {
        console.log('error', error)
      })

    setPartnerToEdit({})

    // ------------------------------
  }, [])

  // partner
  useEffect(() => {
    if (searchData.startSearch) {
      setIsLoading(true)
      getSearch('partner', searchData.str).then(r => {
        setPartnerList(r)
        setSearchData({ ...searchData, startSearch: false })
        setIsLoading(false)
      })
    }

    if (!searchData.startSearch && searchData.str === '') {
      setPartnerList(filteredPartnerList)
    }
  }, [searchData])

  useEffect(() => {
    listUpdate().then(r => {
      const { data } = r

      setFullPartnerList(data)
      setIsLoading(false)
    })
  }, [page])

  useEffect(() => {
    setValue(formData?.whiteLabelId)
    if (fullPartnerList && fullPartnerList.length > 0) {
      const filterPartnerList = fullPartnerList.filter(item => {
        return item.situation === 1
      })
      setPartnerList(filterPartnerList)
    }
    if (formData.Partners) {
      const convertido = formData.Partners?.map(item => {
        return item.id
      })
      setTags(convertido)
    }
  }, [fullPartnerList])

  useEffect(() => {
    try {
      const whiteLabelList = data?.WhiteLabelMuralWhiteLabelLists || []
      const addAssociatedGroupList = whiteLabelList.map(item => {
        return {
          whiteLabelId: item.whiteLabelId,
          whiteLabelMuralId: formData.id,
          title: item.WhiteLabel.title
        }
      })
      setAssociatedGroups(addAssociatedGroupList)

      if (user?.userGroup === 6) {
        getThemesList().then(response => {
          const listWhiteLabel = response?.map(group => {
            const matchedId = addAssociatedGroupList.some(item => item.whiteLabelId === group.id)
            return {
              id: group.id,
              title: group.title,
              associated: matchedId || false
            }
          })
          setGroupsData([
            ...listWhiteLabel,
            {
              id: user?.whiteLabelId,
              title: user?.WhiteLabel?.title,
              associated: true
            }
          ])
        })

        const isThereWhiteLabelId = addAssociatedGroupList.filter(
          item => item.whiteLabelId === user?.whiteLabelId
        )

        if (!isThereWhiteLabelId) {
          setAssociatedGroups([
            ...associatedGroups,
            {
              whiteLabelId: user?.whiteLabelId,
              whiteLabelMuralId: formData.id,
              title: user?.WhiteLabel.title
            }
          ])
        }
        return
      }

      getThemesList().then(response => {
        const listWhiteLabel = response.map(group => {
          const matchedId = addAssociatedGroupList.some(item => item.whiteLabelId === group.id)
          return {
            id: group.id,
            title: group.title,
            associated: matchedId || false
          }
        })
        setGroupsData([
          {
            id: 0,
            title: 'Todas as empresas',
            associated: data?.clubeApp
          },
          ...listWhiteLabel
        ])
      })
    } catch (err) {
      console.log(err)
    }
  }, [user])


  function handleChangeContent(field) {
    return function (event) {
      if (loading) return
      const newData = { ...formData }
      newData[field] = event.target.value
      setFormData(newData)
    }
  }

  function handleTextArea(value) {
    if (loading) return
    setFormData({ ...formData, content: value })
  }

  function handleDateChange(date) {
    setSelectedDate(moment(date).utc().toISOString())
  }

  function handleWhiteLabelGroup(event, id) {

    if (checked.includes(id)) {
      setChecked(checked => checked.filter(item => item !== id))
    } else {
      setChecked([...checked, id])
    }
    setFormData({ ...formData, partnerList: checked })
    const groupsDataNew = groupsData
    const addGroupsNew = groupsDataNew.map(group => {
      if (group.id === id) {
        return {
          ...group,
          associated: event.target.checked
        }
      }
      return group
    })

    setGroupsData(addGroupsNew)

    const checkListGroup = addGroupsNew
      .map(group => {
        if (group.associated) {
          return {
            whiteLabelId: group.id,
            title: group.title,
            whiteLabelMuralId: formData.id
          }
        }
      })
      .filter(group => !!group)
    setAssociatedGroups(checkListGroup)
  }

  function defineFeatured() {
    const currentVal = !formData.featured ? 1 : 0
    setFormData({ ...formData, featured: currentVal })
  }

  async function handleImageChange(event) {
    if (loading || !event.target.files[0]) return

    setFormData({
      ...formData,
      image: event.target.files[0]
    })
  }

  function hideErrorsModal() {
    setErrors(null)
  }

  async function checkData() {
    const errors = []
    // Image
    if (!formData.image) errors.push('Sem imagem carregada')
    // Content
    if (!formData.title) errors.push('Você precisa fornecer um título')
    if (!formData.content && formData.typeHighlight === 'mural')
      errors.push('Você precisa preencher algum conteúdo')
    if (!formData.link && formData.typeHighlight === 'directLink') {
      errors.push('Você precisa preencher um link')
    }

    return errors.length === 0 ? false : errors
  }

  // ##################
  async function saveAsDraft() {
    const errors = await checkData()
    if (errors)
      return setErrors({
        list: errors,
        situation: 3
      })

    execute(3)
  }

  // ##################
  async function update() {
    const errors = await checkData()
    if (errors) {
      return setErrors({
        list: errors,
        situation: 1
      })
    }
    execute(1)
  }

  async function schedule() {
    const errors = await checkData()
    if (errors) {
      setOpenSchedule(false)
      return setErrors({
        list: errors,
        situation: 1
      })
    }

    execute(1)
  }

  // ##################
  async function execute(situation) {
    if (loading) return
    setShowLoadingModal(true)

    try {
      setLoading(true)
      const response = []
      const finalData = {
        ...formData,
        whiteLabelId: user?.whiteLabelId,
        partnerList: tags
      }
      if (finalData.image instanceof File) {
        const path = await ImageUploadToS3(finalData.image, 'images/mural/')
        finalData.image = path
      }

      if (location.state?.createTypeHighlight === undefined) {
        const responseUpdate = await axios.post(
          `${process.env.REACT_APP_API_CORE}highlights/updateHighlight/${formData.id}`,
          finalData
        )
        response.push(responseUpdate)
      } else {
        const responseCreate = await axios.post(
          `${process.env.REACT_APP_API_CORE}highlights/createHighlight`,
          finalData
        )
        response.push(responseCreate)
      }

      setShowLoadingModal(false)
      navigation.push('/highlightslist')
    } catch (err) {
      console.log(err)
      setShowLoadingModal(false)
    }
  }

  const handleChange = event => {
    setValue(event.target.value)
    console.log('valor selecionado: ', typeof event.target.value)
    if (event.target.value === '0') {
      setFormData({
        ...formData,
        whiteLabelId: null
      })
    } else {
      setFormData({
        ...formData,
        whiteLabelId: parseInt(event.target.value)
      })
    }
  }

  const handleChangePartnerList = event => {
    setValue(event.target.value)
    setFormData({
      ...formData,
      whiteLabelId: parseInt(event.target.value)
    })
  }

  const handleSearch = str => {
    if (str.length >= 3) {
      setIsFiltered(true)
      const newList = fullPartnerList.filter(item => {
        return !filter
          ? item.fantasyName.toLowerCase().includes(str.toLowerCase())
          : item.fantasyName.toLowerCase().includes(str.toLowerCase()) && item.situation === filter
      })
      setTempList(newList)
      setPartnerList(newList)
    } else {
      setIsFiltered(false)
    }
    if (str.length === 0) {
      setIsFiltered(false)
      if (filter !== 0) {
        const newList = fullPartnerList.filter(item => {
          return item.situation === filter
        })
        setTempList(newList)
        setPartnerList(newList)
      } else {
        setTempList(fullPartnerList)
        setPartnerList(fullPartnerList)
      }
    }
  }

  const tagChecked = id => {
    const newArr = [...tags]

    return newArr.includes(id)
  }

  const handleCheck = id => {
    const newArr = [...tags]
    if (tags.includes(id)) {
      const i = newArr.indexOf(id)
      if (i > -1) newArr.splice(i)
    } else {
      newArr.push(id)
    }

    setTags([...newArr])
  }

  const columns = [[], [], []];
  tagList.forEach((tag, index) => {
    columns[index % 3].push(tag);
  });

  return (
    <>
      <div className={classes.outerContainer}>
        <Grid item xs={12}>
          {loading ? <LinearProgress marginTop="15px" /> : null}
        </Grid>
        {(() => {
          if (formData.typeHighlight === 'mural') {
            return (
              <div className={classes.content}>
                <div className={classes.main}>
                  <Grid container spacing={3}>
                    <Grid item xs={8}>
                      <Grid className={classes.inputGroup}>
                        <span>Título do post*</span>
                        <input
                          value={formData.title}
                          onChange={handleChangeContent('title')}
                          required
                        />
                      </Grid>
                      <Grid className={classes.inputGroup}>
                        <span>Conteúdo do post*</span>
                        <TextAreaHtml
                          handleEditor={handleTextArea}
                          value={formData.content}
                          rows="5"
                          required
                        />
                      </Grid>
                      <Grid className={classes.inputGroup}>
                        <span>Call to action</span>
                        <input
                          value={formData.calltoaction}
                          onChange={handleChangeContent('calltoaction')}
                        />
                      </Grid>
                      <Grid className={classes.inputGroup}>
                        <span>Link de destino</span>
                        <input value={formData.link} onChange={handleChangeContent('link')} />
                      </Grid>      
                      <CategorySelector
                        tagList={tagList}
                        showCategories={showCategories}
                        setShowCategories={setShowCategories}
                        selectedTag={selectedTag}
                        setSelectedTag={setSelectedTag}
                      />
                    </Grid>
                    <Grid item xs={4}>
                    <ImageUpload image={formData.image} onImageChange={handleImageChange} />
                      <Grid
                        item
                        className={clsx({
                          [classes.hide]: user?.userGroup === 6
                        })}
                      >
                        {
                          user.whiteLabelId === null && (
                            <div className={classes.box}>
                              <h4>Empresas</h4>
                              <div>
                                <ul>
                                  {groupsData?.map(group => (
                                    <li key={group.id}>
                                      <RadioGroup
                                        name="controlled-radio-buttons-group"
                                        value={value}
                                        onChange={handleChange}
                                      >
                                        <FormControlLabel
                                          value={group.id}
                                          control={<Radio />}
                                          label={group.title}
                                          checked={value === group.id}
                                        />
                                      </RadioGroup>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          )
                        }

                      </Grid>
                      <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="flex-start"
                        spacing={2}
                      >
                        <Grid item xs={5}>
                          <ButtonGZ fullWidth variant="main" onClick={update}>
                            {!!data && data.situation === 1 ? 'Atualizar' : 'Publicar'}
                          </ButtonGZ>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </div>
            )
          }
          if (formData.typeHighlight === 'partnerList') {
            return (
              <div className={classes.content}>
                <div className={classes.main}>
                  <Grid container spacing={3}>
                    <Grid item xs={8}>
                      <Grid className={classes.inputGroup}>
                        <span>Título do post*</span>
                        <input
                          value={formData.title}
                          onChange={handleChangeContent('title')}
                          required
                        />
                      </Grid>
                      <Grid className={classes.inputGroup}>
                        <div className={classes.box}>
                          <h4>Lista de Parceiros</h4>
                          <Context.Provider value={{ searchData, setSearchData }}>
                            <TopSearch style={{ marginTop: '0px' }} searchAction={handleSearch} />
                          </Context.Provider>
                          <div>
                            <ul>
                              {partnerList?.map(group => (
                                <li key={group.id}>
                                  <FormControlLabel
                                    value="start"
                                    control={
                                      <Checkbox
                                        checked={tagChecked(group.id)}
                                        onChange={() => handleCheck(group.id)}
                                      />
                                    }
                                    label={group.fantasyName}
                                  />
                                </li>
                              ))}
                            </ul>
                          </div>
                          <Grid item xs={12}>
                            <Context.Provider value={{ page, setPage, totalPages }}>
                              <PaginationComponent />
                            </Context.Provider>
                          </Grid>
                        </div>
                      </Grid>
                      <CategorySelector
                        tagList={tagList}
                        showCategories={showCategories}
                        setShowCategories={setShowCategories}
                        selectedTag={selectedTag}
                        setSelectedTag={setSelectedTag}
                      />
                    </Grid>
                    <Grid item xs={4}>
                    <ImageUpload image={formData.image} onImageChange={handleImageChange} />
                      <Grid
                        item
                        className={clsx({
                          [classes.hide]: user?.userGroup === 6
                        })}
                      >
                        {
                          user.whiteLabelId === null && (
                            <div className={classes.box}>
                              <h4>Empresas</h4>
                              <div>
                                <ul>
                                  {groupsData?.map(group => (
                                    <li key={group.id}>
                                      <RadioGroup
                                        name="controlled-radio-buttons-group"
                                        value={value}
                                        onChange={handleChange}
                                      >
                                        <FormControlLabel
                                          value={group.id}
                                          control={<Radio />}
                                          label={group.title}
                                          checked={value === group.id}
                                        />
                                      </RadioGroup>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          )
                        }

                      </Grid>
                      <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="flex-start"
                        spacing={2}
                      >
                        <Grid contaier direction="row" justify="center" alignItems="flex-start">
                          {/* {!data?.publishedDate && (
                        <Grid item xs={12} style={{ padding: '10px 0' }}>
                          <button
                            className={classes.plainButton}
                            onClick={() => setOpenSchedule(true)}
                            type="button"
                          >
                            Agendar Publicação
                          </button>
                        </Grid>
                      )} */}
                          {/* {!data?.situation === 3 || !data?.publishedDate ? (
                        <Grid item xs={12} style={{ padding: '10px 0' }}>
                          <button
                            type="button"
                            onClick={saveAsDraft}
                            className={classes.plainButton}
                          >
                            Salvar Rascunho
                          </button>
                        </Grid>
                      ) : (
                        ''
                      )} */}
                        </Grid>

                        <Grid item xs={5}>
                          <ButtonGZ fullWidth variant="main" onClick={update}>
                            {!!data && data.situation === 1 ? 'Atualizar' : 'Publicar'}
                          </ButtonGZ>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </div>
            )
          }
          if (formData.typeHighlight === 'directLink') {
            return (
              <div className={classes.content}>
                <div className={classes.main}>
                  <Grid container spacing={3}>
                    <Grid item xs={8}>
                      <Grid className={classes.inputGroup}>
                        <span>Título do destaque*</span>
                        <input
                          value={formData.title}
                          onChange={handleChangeContent('title')}
                          required
                        />
                      </Grid>
                      <Grid className={classes.inputGroup}>
                        <span>Link*</span>
                        <input value={formData.link} onChange={handleChangeContent('link')} />
                      </Grid>
                      <ImageUpload image={formData.image} onImageChange={handleImageChange} />
                      <CategorySelector
                        tagList={tagList}
                        showCategories={showCategories}
                        setShowCategories={setShowCategories}
                        selectedTag={selectedTag}
                        setSelectedTag={setSelectedTag}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Grid
                        item
                        className={clsx({
                          [classes.hide]: user?.userGroup === 6
                        })}
                      >
                        {
                          user.whiteLabelId === null && (
                            <div className={classes.box}>
                              <h4>Empresas</h4>
                              <div>
                                <ul>
                                  {groupsData?.map(group => (
                                    <li key={group.id}>
                                      <RadioGroup
                                        name="controlled-radio-buttons-group"
                                        value={value}
                                        onChange={handleChange}
                                      >
                                        <FormControlLabel
                                          value={group.id}
                                          control={<Radio />}
                                          label={group.title}
                                          checked={value === group.id}
                                        />
                                      </RadioGroup>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          )
                        }

                      </Grid>
                      <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="flex-start"
                        spacing={2}
                      >
                        <Grid contaier direction="row" justify="center" alignItems="flex-start" />

                        <Grid item xs={5}>
                          <ButtonGZ fullWidth variant="main" onClick={update}>
                            {!!data && data.situation === 1 ? 'Atualizar' : 'Publicar'}
                          </ButtonGZ>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </div>
            )
          }
        })()}
      </div>

      <Dialog
        open={!!errors}
        onClose={hideErrorsModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Verificação</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Encontramos os seguintes erros:
            <ul className={classes.ul}>
              {errors?.list?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            Deseja continuar mesmo assim?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonGZ color="secondary" onClick={hideErrorsModal}>
            Não
          </ButtonGZ>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default MuralForm
